import axios from 'axios';
import { req } from './axiosFun';


/**
 * 评论配置 
 **/
// 评论列表，分页
export const CommentList = (params) => { return req("post", "/api/business/listComment", params) };
// 评论保存
export const CommentSave = (params) => { return req("post", "/api/business/saveComment", params) };
// 违规评论，分页
export const ReportList = (params) => { return req("post", "/api/business/listReport", params) };
// 违规评论，处理
export const ReportDeal = (params) => { return req("post", "/api/business/dealReport", params) };
// 用户访问记录，分页
export const VisitLogList = (params) => { return req("post", "/api/business/listVisitLog", params) };
// 预览图列表，分页
export const ThumbnailList = (params) => { return req("post", "/api/business/listThumbnail", params) };
// 预览图保存
export const ThumbnailSave = (params) => { return req("post", "/api/business/saveThumbnail", params) };
// 预览图，上传
export const ThumbnailUpload = () => { return "/api/business/uploadThumbnail" };
// 详情图片列表，分页
export const PicturelList = (params) => { return req("post", "/api/business/listPicture", params) };
// 详情图片，上传
export const PictureUpload = () => { return "/api/business/uploadPicture" };
// 详情图片保存
export const PictureSave = (params) => { return req("post", "/api/business/savePicture", params) };


// 交易订单-s删除交易订单
export const OrderDelete = (params) => { return axios.delete("/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 交易订单-交易订单退款
export const OrderRefund = (params) => { return req("post", "/api/Order/refund", params) };


// WEBPACK FOOTER //
// ./src/api/businessMG.js